import React from 'react';
import { IconButton, Grid, Tooltip } from '@mui/material';
import HelpIcon from '@mui/icons-material/Help';
import { useLang } from '~/hooks/useLang';
import useSystemState from '~/features/System/stores/SystemState';
import { Downgraded } from '@hookstate/core';

export default function DispatchShowProcedureButton() {
  const { translate } = useLang()
  const { windowManager } = useSystemState();
  const isDisable = windowManager()['dispatchProcedure'].procedure?.attach(Downgraded).get()?.length ? false : true

  return (
    <Grid item>
      <Tooltip
        title={translate('See Procedures')}
        componentsProps={{ tooltip: { sx: { fontSize: '14px', padding: '6px 10px' } } }}
      >
        <span style={{ display: 'inline-block' }}>
          <IconButton 
            disabled={isDisable} 
            onClick={() => {
              windowManager()['dispatchProcedure'].open.set(true)
            }}
          >
            <HelpIcon />
          </IconButton>
        </span>
      </Tooltip>
    </Grid>);
}